module.exports = __webpack_public_path__ + "img/background_3.31fda4de.jpg";